import { LoadState } from "../../constants/enums";
import { getUniqueId } from "../../helpers";

export interface QuoteSettingsState {
  defaultCoverage: {
    coverageList: QuoteDefaultCoverage[];
    coverage: QuoteDefaultCoverage;
    loading: LoadState;
    error: string | null;
  };
  defaultRemarks: {
    remarksList: QuoteDefaultRemarks[];
    remarks: QuoteDefaultRemarks;
    loading: LoadState;
    error: string | null;
  };
}

export interface QuoteDefaultCoverage {
  default_coverage_code: string | null;
  line_of_business: string | null;
  default_coverage_name: string | null;
  coverage_details: IAutomobileScheduleCoverage[];
  status: string;
}
export interface QuoteDefaultRemarks {
  remarks_template_code: string | null;
  remarks_template_name: string | null;
  remarks: string | null;
  status: string;
}

export interface IAutomobileScheduleCoverage {
  key: string;
  code: string;
  deductible: string | null;
  description: string | null;
  label: string;
  isTypeOther: boolean;
  isOnlyPremimum: boolean;
  limit: string | null;
  premimum: string | null;
  isDeductible: boolean;
}

export const coverageData: IAutomobileScheduleCoverage[] = [
  {
    key: getUniqueId(),
    code: "TPBI",

    label: "Bodily Injury",
    deductible: "",
    description: "",
    limit: "",
    premimum: "",
    isTypeOther: false,
    isOnlyPremimum: false,
    isDeductible: false,
  },
  {
    key: getUniqueId(),
    code: "TPPD",

    label: "Property Damage",
    deductible: "",
    description: "",
    limit: "",
    premimum: "",
    isTypeOther: false,
    isOnlyPremimum: false,
    isDeductible: false,
  },
  {
    key: getUniqueId(),
    code: "AB",

    label: "Accident Benefits (Standard Benefits)",
    deductible: "",
    description: "",
    limit: "",
    premimum: "",
    isTypeOther: false,
    isOnlyPremimum: false,
    isDeductible: false,
  },
  {
    key: getUniqueId(),
    code: "WIB",

    label: "Income Replacement ($600/$800/$1,000)",
    deductible: "",
    description: "",
    limit: "",
    premimum: "",
    isTypeOther: false,
    isOnlyPremimum: false,
    isDeductible: false,
  },
  {
    key: getUniqueId(),
    code: "MRB",

    label: "Medical Rehabilitation & Attendant Care ($130,000/$1,000,000)",
    deductible: "",
    description: "",
    limit: "",
    premimum: "",
    isTypeOther: false,
    isOnlyPremimum: false,
    isDeductible: false,
  },
  {
    key: getUniqueId(),
    code: "CATIM",

    label:
      "Optional Catastrophic Impairment(additional $1,000,000 added to Standard Benefit or Optional Medical, Rehabilitation & Attendant Care Benefit)",
    deductible: "",
    description: "",
    limit: "",
    premimum: "",
    isTypeOther: false,
    isOnlyPremimum: true,
    isDeductible: false,
  },
  {
    key: getUniqueId(),
    code: "CHHMB",

    label: "Caregiver, Housekeeping & Home Maintenance",
    deductible: "",
    description: "",
    limit: "",
    premimum: "",
    isTypeOther: false,
    isOnlyPremimum: true,
    isDeductible: false,
  },
  {
    key: getUniqueId(),
    code: "DFB",

    label: "Death & Funeral",
    deductible: "",
    description: "",
    limit: "",
    premimum: "",
    isTypeOther: false,
    isOnlyPremimum: true,
    isDeductible: false,
  },
  {
    key: getUniqueId(),
    code: "DCB",

    label: "Dependent Care",
    deductible: "",
    description: "",
    limit: "",
    premimum: "",
    isTypeOther: false,
    isOnlyPremimum: true,
    isDeductible: false,
  },
  {
    key: getUniqueId(),
    code: "IDB",

    label: "Indexation Benefit (Consumer Price Index)",
    deductible: "",
    description: "",
    limit: "",
    premimum: "",
    isTypeOther: false,
    isOnlyPremimum: true,
    isDeductible: false,
  },
  {
    key: getUniqueId(),
    code: "UA",

    label: "Uninsured Automobile",
    deductible: "",
    description: "",
    limit: "",
    premimum: "",
    isTypeOther: false,
    isOnlyPremimum: true,
    isDeductible: false,
  },
  {
    key: getUniqueId(),
    code: "TPDC",

    label: "Direct Compensation-Property Damage",
    deductible: "",
    description: "",
    limit: "",
    premimum: "",
    isTypeOther: false,
    isOnlyPremimum: false,
    isDeductible: true,
  },
  {
    key: getUniqueId(),
    code: "SP",

    label: "Specified Perils (excluding Collision or Upset)",
    deductible: "",
    description: "",
    limit: "",
    premimum: "",
    isTypeOther: false,
    isOnlyPremimum: false,
    isDeductible: true,
  },
  {
    key: getUniqueId(),
    code: "CMP",

    label: "Comprehensive (excluding Collision or Upset)",
    deductible: "",
    description: "",
    limit: "",
    premimum: "",
    isTypeOther: false,
    isOnlyPremimum: false,
    isDeductible: true,
  },
  {
    key: getUniqueId(),
    code: "COL",

    label: "Collision or Upset",
    deductible: "",
    description: "",
    limit: "",
    premimum: "",
    isTypeOther: false,
    isOnlyPremimum: false,
    isDeductible: true,
  },
  {
    key: getUniqueId(),
    code: "AP",

    label: "All Perils",
    deductible: "",
    description: "",
    limit: "",
    premimum: "",
    isTypeOther: false,
    isOnlyPremimum: false,
    isDeductible: true,
  },
  {
    key: getUniqueId(),
    code: "44R",

    label: "Family Protection Coverage - OPCF 44R",
    deductible: "",
    description: "",
    limit: "",
    premimum: "",
    isTypeOther: false,
    isOnlyPremimum: false,
    isDeductible: false,
  },
  {
    key: getUniqueId(),
    code: "",
    label: "",
    deductible: "",
    description: "",
    limit: "",
    premimum: "",
    isTypeOther: true,
    isOnlyPremimum: false,
    isDeductible: false,
  },

  {
    key: getUniqueId(),
    code: "",
    label: "",
    deductible: "",
    description: "",
    limit: "",
    premimum: "",
    isTypeOther: true,
    isOnlyPremimum: false,
    isDeductible: false,
  },
  {
    key: getUniqueId(),
    code: "",
    label: "",
    deductible: "",
    description: "",
    limit: "",
    premimum: "",
    isTypeOther: true,
    isOnlyPremimum: false,
    isDeductible: false,
  },

  {
    key: getUniqueId(),
    code: "",
    label: "",
    deductible: "",
    description: "",
    limit: "",
    premimum: "",
    isTypeOther: true,
    isOnlyPremimum: false,
    isDeductible: false,
  },
  {
    key: getUniqueId(),
    code: "",
    label: "",
    deductible: "",
    description: "",
    limit: "",
    premimum: "",
    isTypeOther: true,
    isOnlyPremimum: false,
    isDeductible: false,
  },

  {
    key: getUniqueId(),
    code: "",
    label: "",
    deductible: "",
    description: "",
    limit: "",
    premimum: "",
    isTypeOther: true,
    isOnlyPremimum: false,
    isDeductible: false,
  },
  {
    key: getUniqueId(),
    code: "",
    label: "",
    deductible: "",
    description: "",
    limit: "",
    premimum: "",
    isTypeOther: true,
    isOnlyPremimum: false,
    isDeductible: false,
  },
];

export const INITIAL_DEFAULT_COVERAGE_STATE: QuoteDefaultCoverage = {
  default_coverage_code: null,
  line_of_business: null,
  default_coverage_name: null,
  coverage_details: coverageData,
  status: "ACTIVE",
};
export const INITIAL_DEFAULT_REMARKS_STATE: QuoteDefaultRemarks = {
  remarks_template_code: null,
  remarks_template_name: null,
  remarks: null,
  status: "ACTIVE",
};

export const initialQuoteSettingsState: QuoteSettingsState = {
  defaultCoverage: {
    coverageList: [],
    coverage: INITIAL_DEFAULT_COVERAGE_STATE,
    loading: LoadState.NotLoaded,
    error: null,
  },
  defaultRemarks: {
    remarksList: [],
    remarks: INITIAL_DEFAULT_REMARKS_STATE,
    loading: LoadState.NotLoaded,
    error: null,
  },
};
